
import { useEffect } from "react";
import { chasers } from "../data/character";
import { useGame } from "../data/gameContext";
import { gameConfig } from "../game/gameConfig";
import generateMap from "../game/map/mapGenerator";


export default function useMapGeneration() {
  const { gameState, updateGameState } = useGame();

  useEffect(() => {
    if (
      gameState.Phase === "mapGeneration" &&
      gameState.PlayerCharacter &&
      !gameState.MapGenerated
    ) {
      setTimeout(() => {
        updateGameState({
          Chasers: structuredClone(chasers),
          GameMap: generateMap(gameConfig.MapWidth, gameConfig.MapHeight),
          PlayerCharacter: {
            ...gameState.PlayerCharacter!,
            Location: { ...gameState.GameTowns[gameState.StartingTownIndex].Location },
          },
          Phase: "mapView",
          MapGenerated: true,
        });
      }, 0);
    }
  }, [gameState.Phase, gameState.PlayerCharacter, gameState.MapGenerated]);
  
}

